export const CHART_HEIGHT = 240;
